import React, { useEffect } from "react";
import WelcomeJourneyFooter from "../WelcomeJourneyFooter";
import { useRouter } from "next/compat/router";
import { useDispatch } from "react-redux";
import { isVisited, welcomeStep } from "@/redux/actions/pwaAction";

const RewardsScreen = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const handleClick = (e) => {
    e.preventDefault();
    //OS-4132 - To fix carousel view hide-hero-carousal class is added
    // document.querySelector("main").classList.add("hide-hero-carousal");
    document.querySelector("#__next").classList.add("pwa-transition");
    setTimeout(() => {
      document.querySelector("#__next").classList.remove("pwa-transition");
      // document.querySelector("main").classList.remove("hide-hero-carousal");
    }, 2000);
  };

  return (
    <>
      <div className="rewards_block" style={{
    backgroundImage: "url('https://cdn.shopify.com/s/files/1/0555/6165/0255/files/RewardsScreen.png?v=1708000706')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  }}>&nbsp;</div>
          
      <WelcomeJourneyFooter
        heading="Olivela Rewards"
        description="As a Rewards member you can earn points (and unlock exclusive extras)
          with every purchase, use your points to shop your favorite items."
        btn1ClickHandler={handleClick}
        btn1_text="Start shopping"
        ga4tag1="App: Welcome > Rewards > Start shopping"
      />
    </>
  );
};

export default RewardsScreen;
